import { createRoute, redirect } from '@tanstack/react-router';

import { queryClient, queryKeys } from '@web/core/query';
import { meRepository } from '@web/data/repositories';
import OrgBoardConfigPage from '@web/ui/org_board_config/views/org_board_config_page';

import { settingsLayoutRoute } from './settings_routes';

/**
 * Guard the board-config settings sub-route. Bounces to the org index
 * when the caller lacks `kanban:org_board_config:edit` — the page is
 * editor-only; read-only viewers do not need a dedicated UI.
 */
async function ensureCanEditBoardConfig(orgSlug: string): Promise<void> {
  const me = await queryClient.ensureQueryData({
    queryKey: queryKeys.me.all,
    queryFn: () => meRepository.getMe(),
  });
  const org = me.orgs.find((o) => o.slug === orgSlug);
  if (!org) return redirect({ throw: true, to: '/' }) as never;

  const perms = await queryClient.ensureQueryData({
    queryKey: queryKeys.me.permissions(org.id),
    queryFn: () => meRepository.getMyPermissions(org.id),
  });
  if (!perms.permissions.includes('kanban:org_board_config:edit')) {
    return redirect({ throw: true, to: '/' }) as never;
  }
}

export const settingsBoardConfigRoute = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: 'board',
  component: OrgBoardConfigPage,
  beforeLoad: ({ params }) => ensureCanEditBoardConfig(params.orgSlug),
});
